// extracted by css-extract-rspack-plugin
export default {"VerifiedIcon":"MarketplaceItem-module__VerifiedIcon__mNjDW3d","Label":"MarketplaceItem-module__Label__Kgi57Nd"};